import React from 'react'
import styled, { css } from 'styled-components'

type SizeTypes = 'small' | 'medium' | 'big' | 'tooltip'

enum IconSize {
  small = '12px',
  tooltip = '15px',
  medium = '24px',
  big = '48px',
  auto = 'auto',
}

enum IconSizeMobile {
  small = '12px',
  tooltip = '15px',
  medium = '24px',
  big = '48px',
  auto = 'auto',
}
interface IconProps {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  iconSize?: SizeTypes
  children?: JSX.Element | JSX.Element[]
  stroke?: string
  fill?: string
  className?: string
  inverse?: boolean
  ignoreColors?: boolean
}

type Props = IconProps & React.HTMLProps<HTMLDivElement>

const SvgContainer = styled.div<Props>`
  height: auto;
  width: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  & svg {
    ${({ iconSize, theme }) => theme.mediaWidth.Mobile`
    width: ${iconSize ? IconSizeMobile[iconSize] : IconSizeMobile.auto}; 
    height: ${iconSize ? IconSizeMobile[iconSize] : IconSizeMobile.auto};
    `}
    ${({ iconSize, stroke, fill, inverse, theme, ignoreColors }) =>
      !ignoreColors &&
      css`
        width: ${iconSize ? IconSize[iconSize] : IconSize.auto};
        height: ${iconSize ? IconSize[iconSize] : IconSize.auto};
        stroke: ${stroke ? stroke : inverse ? theme.inverseIconColor : theme.iconColor};
        fill: ${fill ? fill : 'none'};
        & text {
          fill: ${fill
            ? fill
            : inverse
              ? theme.inverseIconColor
              : stroke
                ? stroke
                : theme.iconColor};
        }
        & path {
          stroke: ${stroke ? stroke : inverse ? theme.inverseIconColor : theme.iconColor};
        }
        & g {
          & path {
            stroke: ${stroke ? stroke : inverse ? theme.inverseIconColor : theme.iconColor};
          }
        }
        & rect {
          stroke: ${stroke ? stroke : inverse ? theme.inverseIconColor : theme.iconColor};
        }
      `}
  }
`

/*
  Using svg as ReactComponent
  import { ReactComponent as SomethingIcon } from 'assets/....svg?react'
  <SvgIcon 
    icon={SomethingIcon} 
    iconSize={'medium'} 
    style={{ marginLeft: '35px' }} 
  />
 */

export const SvgIcon: React.FC<Props> = (props: IconProps) => {
  const Icon = props.icon
  return (
    <SvgContainer {...props}>
      <Icon stroke={props.stroke} />
    </SvgContainer>
  )
}
